import { GetCulpritCustomerDocumentImagesQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritCustomerDocumentImages/getCulpritCustomerDocumentImagesQuery.type';
import { getCulpritCustomerDocumentImagesFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritCustomerDocumentImages/getCulpritCustomerDocumentImagesQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getCulpritCustomerDocumentImagesQueryOptions = (
  params: GetCulpritCustomerDocumentImagesQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['CulpritCustomerDocumentImages', params],
    queryFn: () => getCulpritCustomerDocumentImagesFunction(params),
    enabled: true,
  });
};
